import { Controller, type Control, type FieldValues, type Path, type RegisterOptions } from 'react-hook-form';
import { ToggleButtonGroup, type ToggleButtonGroupProps } from '@mui/material';

type FormToggleButtonGroupFieldProps<TFieldValues extends FieldValues> = {
  name: Path<TFieldValues>;
  control: Control<TFieldValues>;
  rules?: RegisterOptions<TFieldValues, Path<TFieldValues>>;
} & Omit<ToggleButtonGroupProps, 'name' | 'pattern' | 'required' | 'value' | 'defaultValue'>;

export const FormToggleButtonGroupField = <TFieldValues extends FieldValues>({
  control,
  name,
  ...props
}: FormToggleButtonGroupFieldProps<TFieldValues>) => {
  return (
    <Controller control={control} name={name} render={({ field }) => <ToggleButtonGroup {...field} {...props} />} />
  );
};
